import MEGA_CLIENT from './client'
import type { TerminalInstance, TerminalBlock } from '../types'

// NEW: Interface for terminal_block_assignments
export interface TerminalBlockAssignment {
  id: number;
  terminal_block_id: number;
  device_instance_id: number;
  position_in_block: number;
  properties?: any;
  created_at?: string;
}

export interface CreateTerminalInstanceData {
  terminal_block_id: number
  specification_id: number
  position_in_block: number
  quantity?: number
  terminal_color?: string
  properties?: any
}

export interface UpdateTerminalInstanceData {
  specification_id?: number
  position_in_block?: number
  quantity?: number
  terminal_color?: string
  properties?: any
}

// OLD: Keep for backward compatibility (will be deprecated)
export const getTerminalInstances = async (blockId: number): Promise<TerminalInstance[]> => {
  try {
    const response = await MEGA_CLIENT.get('/api/terminal_instances', {
      params: { terminal_block_id: blockId }
    })
    return response.data
  } catch (error) {
    console.error('getTerminalInstances ERROR:', error);
    throw error;
  }
}

// NEW: API function for terminal_block_assignments
export const getTerminalBlockAssignments = async (blockId: number): Promise<TerminalBlockAssignment[]> => {
  try {
    const response = await MEGA_CLIENT.get('/api/terminal_block_assignments', {
      params: { terminal_block_id: blockId }
    })
    return response.data
  } catch (error) {
    console.error('❌ getTerminalBlockAssignments ERROR:', error);
    throw error;
  }
}

export const getTerminalInstance = async (id: number): Promise<TerminalInstance> => {
  const response = await MEGA_CLIENT.get(`/api/terminal_instances/${id}`)
  return response.data as TerminalInstance
}

export const createTerminalInstance = async (data: CreateTerminalInstanceData): Promise<TerminalInstance> => {
  const response = await MEGA_CLIENT.post('/api/terminal_instances', data)
  return response.data as TerminalInstance
}

export const updateTerminalInstance = async ({ 
  id, 
  updates 
}: { 
  id: number
  updates: UpdateTerminalInstanceData 
}): Promise<TerminalInstance> => {
  const response = await MEGA_CLIENT.put(`/api/terminal_instances/${id}`, updates)
  return response.data as TerminalInstance
}

export const deleteTerminalInstance = async (id: number): Promise<void> => {
  await MEGA_CLIENT.delete(`/api/terminal_instances/${id}`)
}

// Get specifications filtered by device types
export const getSpecification = async (
  projectId: number, 
  panelId?: number, 
  deviceTypes?: string[]
): Promise<any[]> => {
  let url = `/api/specification?project_id=${projectId}`
  if (panelId) {
    url += `&electrical_panel_id=${panelId}`
  }
  if (deviceTypes && deviceTypes.length > 0) {
    url += `&device_types=${deviceTypes.join(',')}`
  }
  
  const response = await MEGA_CLIENT.get(url)
  return response.data as any[]
} 

// Get terminal block info
export const getTerminalBlock = async (blockId: number) => {
  try {
    const response = await MEGA_CLIENT.get(`/api/terminal_blocks/${blockId}`)
    return response.data as TerminalBlock
  } catch (error) {
    console.error('❌ Error loading terminal block:', error);
    throw error;
  }
} 

export const deleteAssignment = async (assignmentId: number): Promise<void> => {
  const response = await MEGA_CLIENT.delete(`/api/terminal_block_assignments/${assignmentId}`);
  return response.data;
};

// NEW: Get terminal blocks library for main schema
export const getTerminalBlocksLibrary = async (projectId: number, panelId: number): Promise<any[]> => {
  try {
    const response = await MEGA_CLIENT.get(`/api/terminal_blocks_library?project_id=${projectId}&panel_id=${panelId}`);
    if (Array.isArray(response.data)) {
      return response.data;
    }
    return [];
  } catch (error) {
    console.error('❌ Error fetching terminal blocks library:', error);
    return [];
  }
}; 